namespace GeniuzPOS.Administration {
    export interface PsPosScreenTypeForm {
        PosScreenType: Serenity.StringEditor;
        PosScreenTypeName: Serenity.StringEditor;
    }

    export class PsPosScreenTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsPosScreenType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosScreenTypeForm.init)  {
                PsPosScreenTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsPosScreenTypeForm, [
                    'PosScreenType', w0,
                    'PosScreenTypeName', w0
                ]);
            }
        }
    }
}
